import React from 'react';

export default function AttachmentIcon(props) {
  return (
    <div className={props.className} alt={props.alt}>
      <svg
        width="9"
        height="17"
        viewBox="0 0 9 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.20001 3.64589V11.6111C8.20001 14.7222 6.33335 15.5 4.70001 15.5C3.06668 15.5 1.20001 14.7222 1.20001 11.6111V3.83333C1.20001 3.05556 1.5889 1.5 3.53335 1.5C5.47779 1.5 5.86668 3.05556 5.86668 3.83333V11.8717C5.86668 12.539 5.47779 13.1667 4.70001 13.1667C3.92223 13.1667 3.53335 12.539 3.53335 11.8717V3.83333"
          stroke="#C7D2DD"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
